import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { Input } from "../../../ui/Input/Input";
import { LocationPinIcon } from "../../../ui/icons/LocationPinLightIcon";

export const PostalCodeInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const [{ postalCode }, { setPostalCode }] = useSearchForm();

  return (
    <Input
      onChange={(event): void => {
        setPostalCode(event.target.value);
      }}
      aria-label="postalCode"
      before={<LocationPinIcon />}
      defaultValue={postalCode ?? ""}
      name="postalCode"
      placeholder={t("searchForm.enterPostalCode")}
      ring={!postalCode}
    />
  );
};
